import { createReducer, on } from '@ngrx/store';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { BillingSuboperatorsState } from './billing.suboperators.models';
import { Pagination } from '../../../shared/models/list.page.model';
import * as suboperatorsActions from './billing.suboperators.actions';

export const billingSuboperatorsInitialState: BillingSuboperatorsState = {
  loading: false,
  error: null,
  subCpos: [],
  subCposPage: null,
  pagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  filterParameters: null,
  currentFilter: null,
};

export const billingSuboperatorsReducer = createReducer(
  billingSuboperatorsInitialState,
  on(suboperatorsActions.initSuboperators, (state) => ({
    ...state,
    pagination: {
      pageIndex: 0,
      pageSize: state.pagination ? state.pagination.pageSize : paginationConstants.DefaultPageSize,
    } as Pagination,
  })),
  on(suboperatorsActions.loadSubCpos, (state) => ({
    ...state,
    loading: true,
  })),
  on(suboperatorsActions.loadSubCposSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    subCpos: response.result ?? [],
    subCposPage: {
      pageIndex: response.pageIndex ?? 0,
      pageSize: response.pageSize ?? 0,
      totalCount: response.total ?? 0,
    },
  })),
  on(suboperatorsActions.loadSubCposFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(suboperatorsActions.loadSubCpoFilterParameters, (state) => ({
    ...state,
    filterParameters: null,
  })),
  on(suboperatorsActions.loadSubCpoFilterParametersSuccess, (state, { filterParameters }) => ({
    ...state,
    filterParameters,
  })),
  on(suboperatorsActions.changeSubCpoFilter, (state, { filter }) => ({
    ...state,
    currentFilter: { ...filter },
    pagination: {
      pageIndex: 0,
      pageSize: state.pagination ? state.pagination.pageSize : paginationConstants.DefaultPageSize,
    } as Pagination,
  })),
  on(suboperatorsActions.changeSubCpoPagination, (state, { pageIndex, pageSize }) => ({
    ...state,
    pagination: { pageIndex, pageSize },
  })),
  on(suboperatorsActions.reinviteSubCpoToOnboarding, (state) => ({
    ...state,
    loading: true,
  })),
  on(suboperatorsActions.reinviteSubCpoToOnboardingSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(suboperatorsActions.reinviteSubCpoToOnboardingFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(suboperatorsActions.blockSubCpo, (state) => ({
    ...state,
    loading: true,
  })),
  on(suboperatorsActions.blockSubCpoSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(suboperatorsActions.blockSubCpoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
);
